import setStatusUsers from './setStatusUsers';
import setMoreStatusUsers from './setMoreStatusUsers';
import reset from './reset';

export default {
  setStatusUsers,
  setMoreStatusUsers,
  reset,
};
